import { render, staticRenderFns } from "./academic-cap.vue?vue&type=template&id=2b5334d8&"
import script from "./academic-cap.vue?vue&type=script&lang=js&"
export * from "./academic-cap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports